import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import validIcon from '../../assets/images/register/green_check.png';
import editIcon from '../../assets/images/register/edit.png';
import indiaFlag from "../../assets/images/register/india.svg";
import { country_dialcodes } from "../../constants/registration";
import { components } from "react-select";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import {
  clearUserLoginSignupOtpResponse
} from "../../../store/slices/Registration/CommonSlices";
import {gaEvent, gaLocationAndContentData} from "../../utils/index";

const CareersRegisterOtpVerify = (props) => {
  const { values, setFieldValue, errors, touched, handleBlur } = props;
  const [selectedCountry, setSelectedCountry] = useState({});
  const [isEditClicked, setIsEditClicked] = useState(false);
  const mobileInputRef = useRef(null);
  const cookies = new Cookies();

// this is commented for when registration will be live for all country codes
  // let defaultCountry = props.countryCodeData?.values?.find((item) => item.value == "+91")
  // useEffect(() => {
  //   if (props.countryCodeData) {
  //     setSelectedCountry(defaultCountry)
  //   }
  // }, [props.countryCodeData])

  useEffect(() => {
    if (props.userLoginSignupOtp) {
      setIsEditClicked(false);
    }
  }, [props.userLoginSignupOtp])

  const handleEdit = (e) => {
    gaEvent("otpchangemobilesignup", "login_signup", `${gaLocationAndContentData}`, "");
    props.dispatch(clearUserLoginSignupOtpResponse())
    props.setShowSuccessCard()
    setIsEditClicked(true);
    props.setFormCurrentState((prev) => ({
      ...prev, isMobileEditing: true
    }))
    setTimeout(() => {
      props.setEditMobile(true)
      if (mobileInputRef.current) {
        mobileInputRef.current.focus();
      }
    }, 10)
  }
  
  const Menu = (props) => {
    return (
      <div>
        <components.Menu {...props}>
          <span className="country_code_heading">Select country code</span>
          <input type="search" placeholder="Search..." className="country_code_search" />
          {props.children}
        </components.Menu>
      </div>
    );
  };

  const handleCountry = (obj) => {
    setSelectedCountry(obj);
  };
  const handleKeyPress = (e, name) => {
    if (name == "mobile") {
      if (values?.mobile?.length > 9) {
        e.preventDefault();
      }
    }
  };
  return (
    <div className='careers_register_otp_verify'>
      <div className="careers_register_otp_verify_text">OTP Sent to</div>
          {/* <Select
            placeholder={<img src={indiaFlag} alt="indiaFlag" />}
            isSearchable={false}
            options={props.countryCodeData?.values}
            isDisabled={selectedCountry?.value == "+91"}
            getOptionLabel={(opt) => `${opt.country_image}  ${opt.country__name}`}
            getOptionValue={(opt) => opt.country_id}
            // value={selectedCountry}
            components={{ Menu: Menu }}
            onChange={(obj) => handleCountry(obj)}
            styles={{
              control: (base, state) => ({
                ...base,
                background: 'transparent',
                borderRadius: '0px',
                minHeight: '42px',
                minWidth: '50px',
                borderWidth: '0px',
                minHeight: '24px',
                boxShadow: 'none',
                ":hover": {
                  borderColor: '#ccc',
                },
                ":after": {
                  content: "' '",
                  width: '0px',
                  height: '0px',
                  position: 'absolute',
                  top: '10px',
                  left: '34px',
                  borderLeft: '5px solid transparent',
                  borderRight: '5px solid transparent',
                  borderTop: '5px solid #999999',
                }
              }),
              valueContainer: (base, state) => ({
                ...base,
                padding: '0px 0px',
                maxWidth: '26px',
              }),
              input: (base, state) => ({
                ...base,
                paddingBottom: '0px',
                paddingTop: '0px',
                margin: '0px',
              }),
              indicatorsContainer: (base, state) => ({
                ...base,
                display: 'none',
              }),
              menu: (base, state) => ({
                ...base,
                marginTop: '10px',
                minWidth: '290px',
                left: '-10px',
              }),
            }}
          /> */}
              <span className={"register_country_logo_margin"}
                >
                    <img src={indiaFlag} alt="indiaFlag" />
              </span>
              {(props.values?.mobile || touched?.mobile) && (<>
                <span className="register_country_code">{"+91"}</span>
            </>)}
      <div className="careers_register_otp_verify_number">
        {(isEditClicked || props.formCurrentState?.isMobileEditing || props.usersAuthenticationError || props.usersLoginSignupOtpError) ? (
          <>
            <input
              type="text"
              name="mobile"
              className={(errors?.mobile && touched?.mobile) || props.usersAuthenticationError ? "input_type_number underline_on_error" : "input_type_number underlined_input"}
              placeholder="Enter Number"
              value={props.values?.mobile}
              onChange={(e) => {
                props.dispatch(clearUserLoginSignupOtpResponse())
                const sanitizedValue = e.target.value?.replace(/[^\d]/g, '');
                setFieldValue("mobile", sanitizedValue);
              }}
              onKeyPress={(e) => {
                handleKeyPress(e, "mobile");
              }}
              ref={mobileInputRef}
              // autoFocus
              //   tabIndex={1}
              required
            />
            {
              values?.mobile && !errors.mobile && props.usersAuthentication && values?.mobile?.length === 10
              && (props.editMobile || props.formCurrentState?.isMobileEditing) && !props.usersLoginSignupOtpError && (
                <img
                  src={validIcon}
                  alt="careers_register_checkIcon"
                  className="careers_register_valid_icon valid_icon_verify_screen"
                />
              )}
          </>
        ) : (
          <input
            type="text"
            name="mobile"
            className="input_type_number underlined_input"
            placeholder="Enter Number"
            value={props.values?.mobile || "jdkjshdshjk"}
            readOnly
          />
        )}
      </div>
      {(!props.editMobile && !props.formCurrentState?.isMobileEditing && (!props.usersLoginSignupOtpError || props.usersLoginSignupOtpError?.block_user_case === "try_again")) &&
        <div onClick={handleEdit} className="careers_register_otp_verify_edit_number">
          <img src={editIcon} alt="edit" />
          <small>Edit mobile number</small>
        </div>}

      {errors.mobile && touched?.mobile && (
        <div className="otp_verify_invalid_card">
          <span className="invalid_card_text">{errors.mobile}</span>
        </div>
      )}
      {(props.usersAuthenticationError?.authorization === false || props.usersLoginSignupOtpError?.block_user_case == "user_restricted" 
                || props.usersLoginSignupOtpError?.block_user_case == "otp_exceed") && !errors?.mobile && (
        <div className="otp_verify_invalid_card">
          <span className="invalid_card_text">Mobile error, <a href="https://www.careers360.com/grievance-redressal" className="contact_support_text">contact support</a></span>
        </div>
      )}
      {props.userAccountLimitError?.block_user_case == "account_limit_exceed" && !errors.mobile && 
      <div className="otp_verify_invalid_card">
          <span className="invalid_card_text">Mobile error, try  <a href= {`${window.location.origin}/user/login${window.location.search}`} className="contact_support_text">login </a> or <a href="https://www.careers360.com/grievance-redressal" target="_blank" rel="noopener noreferrer" className="contact_support_text">contact support</a></span>
        </div>
      }
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    userLoginSignupOtp: state.usersCommonData.userLoginSignupOtp,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    countryCodeData: state.usersCommonData?.countryCode,
    usersAuthenticationError: state.usersCommonData?.userAuthenticationError,
    userAccountLimitCheck: state.usersCommonData?.userAccountLimit,
    userAccountLimitError: state.usersCommonData?.userAccountLimitError,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterOtpVerify);